import React, { useEffect, useState } from 'react'

import { formatMoney, formatMoneyInput } from 'helpers/helpers'
import { httpOk, GET, PUT } from 'helpers/api'

// Пакеты тарификации: что входит в «Старт» / «Бизнес» / «Премиум» / «Произвольный».
// Галочка = функция у всех точек пакета без отдельного модуля. Цена — прайс для новых точек
// и потолок скидки агента, у существующих точек цена своя и от этого не меняется.
function TariffPlans() {
	const [plans, setPlans] = useState([])
	const [features, setFeatures] = useState([])
	const [drafts, setDrafts] = useState({})

	async function loadPlans() {
		const response = await GET('/admin/tariff-plans', {}, { silent: true })
		if (httpOk(response)) {
			setPlans(response.data?.data || [])
			setFeatures(response.data?.features || [])
			setDrafts({})
		}
	}

	function draftOf(plan) {
		return drafts[plan.code] || { features: { ...plan.features }, price: plan.price ?? '' }
	}

	function changeDraft(plan, patch) {
		const current = draftOf(plan)
		setDrafts({ ...drafts, [plan.code]: { ...current, ...patch } })
	}

	async function save(plan) {
		const draft = draftOf(plan)
		const response = await PUT('/admin/tariff-plans', {
			code: plan.code,
			features: draft.features,
			price: plan.has_list_price ? String(draft.price).replace(/\s/g, '') : null,
		}, { loader: true })
		if (httpOk(response)) loadPlans()
	}

	useEffect(() => {
		loadPlans()
	}, [])

	if (plans.length === 0) return null

	return (
		<div className="card mb-3">
			<div className="card-body">
				<h5 className="mb-1">Пакеты</h5>
				<p className="text-muted mb-3" style={{ fontSize: 12 }}>
					Отмеченное входит в пакет — у всех его точек работает без отдельного модуля.
					Цена «Старта» и «Бизнеса» — прайс для новых точек, у уже подключённых цена своя.
					«По старому договору» не правится: там у каждой точки свои модули из снимка 05.11.
				</p>
				<div className="table-responsive">
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th>Пакет</th>
								<th className="text-end" style={{ minWidth: 130 }}>Цена</th>
								{features.map(feature => (
									<th key={feature.code} className="text-center">{feature.name}</th>
								))}
								<th className="text-end">Точек</th>
								<th style={{ minWidth: 40 }}></th>
							</tr>
						</thead>
						<tbody>
							{plans.map(plan => {
								const draft = draftOf(plan)
								const isDirty = !!drafts[plan.code]
								return (
									<tr key={plan.code}>
										<td>{plan.name}</td>
										<td className="text-end">
											{plan.has_list_price
												? <input type="text" className="form-control form-control-sm text-end"
													value={formatMoneyInput(draft.price) ?? ''}
													onChange={(e) => changeDraft(plan, { price: e.target.value.replace(/[^0-9.]/g, '') })} />
												: <span className="text-muted">{plan.price ? formatMoney(plan.price) : 'своя у точки'}</span>
											}
										</td>
										{features.map(feature => (
											<td key={feature.code} className="text-center">
												<input type="checkbox" className="form-check-input"
													disabled={!plan.is_editable}
													checked={!!draft.features[feature.code]}
													onChange={(e) => changeDraft(plan, {
														features: { ...draft.features, [feature.code]: e.target.checked },
													})} />
											</td>
										))}
										<td className="text-end">{plan.poses_count}</td>
										<td className="text-end">
											{plan.is_editable &&
												<button type="button" className="btn btn-sm btn-primary"
													disabled={!isDirty}
													onClick={() => save(plan)}>
													Сохранить
												</button>
											}
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

export default TariffPlans
